import * as React from "react";
import { BaseComponent } from "../../../../react-core/Html/BaseComponent";
import { AppLogo } from "../AppLogo";

export type IProcessHeaderProps = React.Props<ProcessHeader>;

export interface IProcessHeaderState {}

export class ProcessHeader extends BaseComponent<IProcessHeaderProps, IProcessHeaderState> {
    constructor(props: any) {
        super(props);
    }

    public render(): JSX.Element {
        return (
            <header>
                <div className="layout-process-header">
                    <div className="container">
                        <AppLogo />
                    </div>
                </div>
            </header>
        );
    }
}
